<template>
<div>
    <b-container class="px-0">

        <b-row class="justify-content-md-center">
            <b-col cols=12>
                <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent">{{pageTitle}}
                </b-card>
            </b-col>
        </b-row>

        <b-row id="catalogopac" class="justify-md-content-center text-center">
            <b-col cols=12>
                <b-form>
                    <b-input id="search_form" placeholder="Scrie aici expresia căutată..." v-model="searchQuery"></b-input>
                    <b-button variant="primary" class="my-4 px-4" @click="submitSearch">Caută</b-button>
                </b-form>
            </b-col>
        </b-row>


        <b-row class="justify-content-md-center" v-if="fara_rezultat">
            <b-col cols="12" md="6" xl="4" class="mb-4">
                
                <b-card
                    tag="article"
                    class="shadow p-0 mb-4 rounded bg-transparent"
                    fluid>
                    <b-card-title title-tag="h3" >Nu s-a găsit niciun rezultat!</b-card-title>
                    <div class="d-flex justify-content-center">
                        <b-button squared variant="primary" class="px-4 my-2 btn-index-card" v-on:click="revino">
                            Revino la pagina inițială
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center">
            <b-col cols="12" md="6" xl="4" class="mb-4" v-for="l in list" :key="l['o:id']">
                
                <b-card
                    :img-src="l['foaf:depiction'] ? l['foaf:depiction']['0']['@id'] : require('../assets/imgplacehold.png')"
                    img-alt="Biblioteca Județeană Arad"
                    img-top
                    tag="article"
                    class="shadow p-0 mb-4 rounded bg-transparent"
                    fluid>
                    <b-card-title title-tag="h3" v-html="l['dcterms:title']['0']['@value']"> </b-card-title>

                    <b-card-text v-if="l['desc']" v-html="l['desc']" class="py-1"> </b-card-text>
                    <b-card-text v-if="l['creat']" class="py-1"> {{l['creat'] | formatDate}} </b-card-text>

                    <div class="d-flex justify-content-center">
                        <b-button squared variant="primary" class="px-4 my-2 btn-index-card">
                            <router-link :to="{ path: '/continutdigital/'+ l['o:id']}">Vezi detalii</router-link>
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>


        <b-row class="justify-content-md-center" v-if="list.lenght > 1">
            <b-col cols="12" md="6" xl="4" class="mb-4" v-for="l in list" :key="l['o:id']">
                <b-card class="shadow p-0 mb-4 rounded bg-transparent" fluid>
                    <b-card-title title-tag="h3" v-html="l['dcterms:title']['0']['@value']"> </b-card-title>
                    <b-card-img v-if="l['foaf:depiction']"  :src="l['foaf:depiction']['0']['@id']"></b-card-img>

                    <b-card-text v-if="l['desc']" v-html="l['desc']" class="py-1"> </b-card-text>
                    <b-card-text v-if="l['creat']" class="py-1"> {{l['creat'] | formatDate}} </b-card-text>

                    <div class="d-flex justify-content-center">
                        <b-button squared variant="primary" class="px-4 my-2 btn-index-card">
                            <router-link :to="{ path: '/continutdigital/'+ l['o:id']}">Vezi detalii</router-link>
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row> 

        <b-col cols="12" md="6" xl="4" class="mb-4" v-for="item in sub" v-bind:key="item['o:id']">
            <b-card class="shadow p-0 mb-4 rounded bg-transparent" fluid>
                <b-card-title title-tag="h3" v-html="item['o:title']"> </b-card-title>
                <b-card-img v-if="item['foaf:depiction']"  :src="item['foaf:depiction']['0']['@id']"></b-card-img>

                <b-card-text v-if="item['desc']" v-html="item['desc']" class="py-1"> </b-card-text>
                <b-card-text v-if="item['creat']" class="py-1"> {{item['creat'] | formatDate}} </b-card-text>

                <div class="d-flex justify-content-center">
                    <b-button squared variant="primary" class="px-4 my-2 btn-index-card">
                        <router-link :to="{ path: '/continutdigital/'+ item['o:id']}">Vezi detalii</router-link>
                    </b-button>
                </div>
            </b-card>
        </b-col>

    </b-container>

    <infinite-loading @infinite="infiniteHandler">
        <div slot="spinner">Se încarcă...</div>
        <div slot="no-more">Listă de articole epuizată.</div>
        <div slot="no-results">Fără rezultate.</div>
    </infinite-loading>
</div>
</template>

<script>
import moment from 'moment'; 
import Vue from 'vue';


Vue.filter('formatDate', function (value) {
    if (value) {
        return 'Adaugat : ' + moment(String(value)).format('MM/DD/YYYY hh:mm');
    }
});

export default {
    data() {
        return {
            pageTitle: 'Biblioteca Digitală',
            page: 1,
            list: [],
            infiniteId: +new Date(),
            eroare: '',
            src: '',
            search: '',
            sub: [],
            isResult: false,
            searchQuery: '',
            searchData: '',
            fara_rezultat : false,
        };
    },
    methods: {
        removeSearchQuery: function () {
            this.searchQuery = '';
            this.isResult = false;
        },
        revino: function() {
            this.fara_rezultat = false;
            this.searchQuery = '';
            var reqURL = 'https://digital.bibliotecaarad.ro/api/items?item_set_id=' + this.$route.params.id + '&sort_by=created&sort_order=desc';
            fetch(reqURL)
                .then(response => response.json())
                .then(data => {

                    this.isResult = true;
                    if (data.length) {
                        this.list = [];
                        this.list = data;
                    }
                    // verificam daca cautarea are rezultate si daca nu are scoatem itemele existente.
                    // sa generam un card cu erroare si daca se sterge cuvantul cheie sa revina la informatiile precedente
                    if(data.length == 0) {
                        //alert('Nu exista rezultate!');
                        this.list = [];
                        this.fara_rezultat = true;
                    }
                    //sfarsit validare cautare

                    console.log(data);
                });
        },
        submitSearch: function () {
            var reqURL = 'https://digital.bibliotecaarad.ro/api/items?item_set_id=' + this.$route.params.id + '&sort_by=created&sort_order=desc&search=' + this.searchQuery;
            fetch(reqURL)
                .then(response => response.json())
                .then(data => {

                    this.isResult = true;
                    if (data.length) {
                        this.list = '';
                        this.sub = data;
                    }
                    // verificam daca cautarea are rezultate si daca nu are scoatem itemele existente.
                    // sa generam un card cu erroare si daca se sterge cuvantul cheie sa revina la informatiile precedente
                    if(data.length == 0) {
                        this.list = [];
                        this.fara_rezultat = true;
                    }
                    //sfarsit validare cautare

                    console.log(data);
                });

        },
        infiniteHandler($state) {

            let url = 'https://digital.bibliotecaarad.ro/api/items?item_set_id=' + this.$route.params.id + '&page=' + this.page + '&per_page=12&sort_by=created&sort_order=desc';

            if (this.searchQuery.length > 1) {
                this.url = 'https://digital.bibliotecaarad.ro/api/items?item_set_id=' + this.$route.params.id + '&page=' + this.page + '&per_page=12&sort_by=created&sort_order=desc&search=' + this.searchQuery;
            }
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    if (data.length) {
                        this.page += 1;
                        this.list.push(...data);
                        $state.loaded();
                        console.log(data);
                    } else {
                        $state.complete();
                    }
                }).catch(error => {
                    $state.complete();
                    this.eroare = error.response;
                });
        },
        cauta() {
            this.infiniteHandler();
        },
        changeType() {
            this.page = 1;
            this.list = [];
            this.infiniteId += 1;
        },
        created() {

        },
    }
};
</script>

